import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Fuse from 'fuse.js';

import { AuthContext } from '../contexts/auth/Store';

import CallRepHeader from '../components/headers/CallRepHeader';
import ManufacturerSaleOfficer from '../components/sale_officer/ManufacturerSaleOfficer';
import SaleOfficerModal from '../components/modals/SaleOfficerModal';
import http from '../utils/http';

export default function CallRepScreen({ navigation, route }) {
  const authContext = React.useContext(AuthContext);
  const token = authContext.getUserData.userToken;
  const buyer = authContext.getUserData.buyerId;

  const [filtered, setFiltered] = React.useState([])
  const [sellers, setSellers] = React.useState([])
  const [manufacturers, setManufacturers] = React.useState([])
  const [loadingContent, setLoadingContent] = React.useState(false)
  const [queryString, setQueryString] = React.useState('')
  const [modalActive, setModalActive] = React.useState(false)
  const [selectedSeller, setSelectedSeller] = React.useState(null)

  const hideModal = () => {
    setModalActive(false)
    setSelectedSeller(null)
  }

  const commitSeller = (manufacturer) => {
    setLoadingContent(true)
    setModalActive(true)
    let form = new FormData()
    form.append('manufacturer_id', manufacturer._id)
    form.append('buyer_id', buyer)
    http.post('seller_area/get_phone', form, token)
      .then(res => {
        if(res.code===200 && res.data) {
          let seller_details = sellers.find(seller => seller._id === res.data.seller_id)
          res.data['seller_details'] = seller_details
          res.data['manufacturer_details'] = manufacturer
          setSelectedSeller(res.data)
        }
        setLoadingContent(false)
      }).catch(err => {
        console.log(err)
      })
  }

  const fetch_data = (retry) => {
    const getManufacturers = http.post('manufacturer/read_all', null, token)
    const getSalesOfficers = http.post('sales_officer/read_all', null, token)
    const getSellers = http.post('seller/read_all', null, token)

    Promise.all([getSalesOfficers, getManufacturers, getSellers])
      .then(([salesOfficers, manufacturers, sellers]) => {
        // if (salesOfficers.data.length > 0) {
        //   let combined = salesOfficers.data.map(officer => {
        //     const _manufacturer = manufacturers.data.filter(item => item._id === officer.seller.manufacturer_id)
        //     officer['manufacturer'] = _manufacturer[0]
        //     return officer
        //   })
        //   setOfficers(combined)
        // }
        if (manufacturers.data.length) {
          const active = manufacturers.data.filter(manufacturer => {
            return manufacturer.status === 'active'
          })
          setManufacturers(active)
        }
        if (sellers.data.length) {
          const active = sellers.data.filter(seller => {
            return seller.status === 'active'
          })
          setSellers(active)
        }
      }).catch(e => {
        if (typeof retry !== 'number') {
          return
        }
        if (retry === 0) {
          return
        }
        if (retry > 0) {
          retry -= 1
        }
        // all conditions met retry after 1 minute
        setTimeout(() => { fetch_data(retry) }, 60000)
      })
  }

  React.useEffect(() => {
    var options = {
      shouldSort: true,
      threshold: 0.6,
      location: 0,
      distance: 100,
      minMatchCharLength: 2,
      keys: [{
        name: 'name',
        weight: 0.5
      },
      {
        name: 'manufacturer.name',
        weight: 0.7
      }]
    }

    let fuse = new Fuse(manufacturers, options);
    const matched = fuse.search(queryString);

    setFiltered(matched.map(item => item.item))
  }, [queryString])

  React.useEffect(() => {
    fetch_data(5)
    return () => {
    };
  }, []);

  return (
    <>
      <View style={{
        flex: 1,
        flexGrow: 1,
      }}>
        <CallRepHeader navigation={navigation} route={route} setQueryString={setQueryString} />
          {filtered.length > 0
            ? <ManufacturerSaleOfficer list={filtered} commitSeller={commitSeller} />
            : <ManufacturerSaleOfficer list={manufacturers} commitSeller={commitSeller} />
          }
      </View>
      <SaleOfficerModal isActive={modalActive} loadingContent={loadingContent} seller={selectedSeller} hideModal={hideModal} />
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fafafa',
  },
  contentContainer: {
    paddingTop: 15,
  },
  optionIconContainer: {
    marginRight: 12,
  },
  option: {
    backgroundColor: '#fdfdfd',
    paddingHorizontal: 15,
    paddingVertical: 15,
    borderWidth: StyleSheet.hairlineWidth,
    borderBottomWidth: 0,
    borderColor: '#ededed',
  },
  lastOption: {
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  optionText: {
    fontSize: 15,
    alignSelf: 'flex-start',
    marginTop: 1,
  },
});
